import { render, staticRenderFns } from "./editPermissions.vue?vue&type=template&id=d1f8f49a&"
import script from "./editPermissions.vue?vue&type=script&lang=js&"
export * from "./editPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports